import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";
const StyledTableCell = styled(TableCell)(() => ({
    padding: '9px',
    textAlign: 'right',
}));
const RowHeaderTableCell = styled(TableCell)(() => ({
    padding: '9px',
    textAlign: 'left',
    fontWeight: 'bold',
}));
const FracVsRefracComparisonTable = ({ title, data }) => {
    return (_jsxs(Box, { sx: {
            display: "flex",
            flexDirection: "column",
            gap: '10px',
            backgroundColor: 'white',
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            borderRadius: '12px',
            padding: '20px'
        }, children: [_jsx(Typography, { variant: "h6", sx: { fontWeight: "bold" }, children: title }), _jsx(TableContainer, { sx: {
                    borderRadius: '6px',
                    backgroundColor: 'white',
                    border: '1px solid #E8E6E6',
                }, children: _jsxs(Table, { children: [_jsx(TableHead, { sx: { backgroundColor: "#F9F9F9", textTransform: 'uppercase', color: '#84818A', fontWeight: 'bold' }, children: _jsxs(TableRow, { children: [_jsx(StyledTableCell, {}, "Empty"), data.columnHeaders.map((header, index) => {
                                        return (_jsx(StyledTableCell, { children: header }, index));
                                    })] }) }), _jsx(TableBody, { children: data.rowHeaders.map((row, index) => {
                                return (_jsxs(TableRow, { children: [_jsx(RowHeaderTableCell, { children: row }), data.data[index].map((value, index) => {
                                            return (_jsx(StyledTableCell, { children: value }, index));
                                        })] }, index));
                            }) })] }) })] }));
};
export default FracVsRefracComparisonTable;
